import 'angular:locale/data:cs';
import 'zone.js';(globalThis.$localize ??= {}).locale = "cs";
